import { CircularProgress, Stack, Tooltip } from '@mui/material';
import { PrimaryActionButton } from './PrescriptionAssistantToolActions.styles';
import type { PrescriptionAssistantToolActionsProps } from './PrescriptionAssistantToolActions.types';
import { usePrescriptionAssistantActions } from './usePrescriptionAssistantActions';

export const PrescriptionAssistantToolActions = ({
  primaryButtonLabel,
  extraButtons,
  onCreateScript,
  isLoading,
}: PrescriptionAssistantToolActionsProps) => {
  const { primaryButtonTooltip, handleReviewFlow, isPrimaryButtonDisabled } = usePrescriptionAssistantActions({
    isLoading,
    onCreateScript,
  });

  return (
    <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2} my={10}>
      {extraButtons}
      <Tooltip title={primaryButtonTooltip} placement="top-start">
        <span>
          <PrimaryActionButton
            variant="contained"
            color="secondary"
            onClick={handleReviewFlow}
            disabled={isPrimaryButtonDisabled}
            startIcon={isLoading ? <CircularProgress size={16} /> : null}
          >
            {primaryButtonLabel}
          </PrimaryActionButton>
        </span>
      </Tooltip>
    </Stack>
  );
};
